import { ReportSlideKey } from '../interfaces';
import { ReportType, ReportTypes } from './report-type.const';

/**
 * Defines the ordered list of slides for each report type.
 * Slides are agnostic—the same slide key can appear in multiple report types.
 * Each report type determines which slides are included and their display order.
 */
export const ReportTypeSlideConfig: Record<ReportType, ReportSlideKey[]> = {
	[ReportTypes.EightyTwenty]: [
		'report-title',
		'report-contents',
		'report-executive-summary',
		'period-comparison-overview',
		'profitability-section',
		'profitability-curve-actual',
		'profitability-curve-phase-1',
		'profitability-curve-phase-2',
		'profitability-curve-model',
		'profitability-curve-overhead',
		'quad-section',
		'quad-overview',
		'quad-revenue-distribution',
		'quad-margin',
		'quad-period-comparison-overview',
		'quad-period-comparison-1-2',
		'quad-period-comparison-3-4',
		'customer-product-section',
		'customer-distribution',
		'product-distribution',
		'quartile-section',
		'quartile-customer-product-revenue',
		'quartile-customer-breakdown',
		'quad-4-section',
		'quad-4-customer-observations',
		'quad-4-product-observations',
		'quad-4-breakeven',
		'quad-1-section',
		'quad-1-top-customers',
		'quad-1-top-products',
		'recommendations-section',
		'recommendations-overview',
		'appendix-section',
		'appendix-quad-table',
		'appendix-quad-summary',
		'appendix-quartile-table',
		'appendix-quartile-summary',
	],
	[ReportTypes.QBR]: ['qbr-section'],
};
